<template>
  <div class="password-view-change-parts">
    <atom-input-password
      class="password-view-change-parts__input"
      v-model="password"
      :id="id"
      :textVisible="textVisible"
      :error="error"
      :placeholder="placeholder"
      :isReadOnly="isReadOnly"
      @enter="emitEnter"
      @focus="emitFocus"
      @blur="emitBlur"
    />
    <button
      v-if="!isReadOnly"
      type="button"
      class="password-view-change-parts__button"
      :class="{ 'password-view-change-parts__button--text': textVisible }"
      @click="changeInputType"
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2 9L5.43826 6.24939C6.44922 5.44062 7.70534 5 9 5C10.2947 5 11.5508 5.44062 12.5617 6.24939L16 9L12.5617 11.7506C11.5508 12.5594 10.2947 13 9 13C7.70534 13 6.44922 12.5594 5.43826 11.7506L2 9ZM9 11.5C10.3807 11.5 11.5 10.3807 11.5 9C11.5 7.61929 10.3807 6.5 9 6.5C7.61929 6.5 6.5 7.61929 6.5 9C6.5 10.3807 7.61929 11.5 9 11.5Z"
          fill="#000"
        />
      </svg>
    </button>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'
import AtomInputPassword from '@/components/atoms/input/AtomInputPassword.vue'

type DataType = {
  textVisible: boolean
}
/**
 * Password 表示切り替え対応 バーツ
 */
export default defineComponent({
  name: 'PasswordWithToggleButtonParts',
  components: {
    AtomInputPassword,
  },
  data(): DataType {
    return {
      /**
       * パスワード テキスト表示フラグ
       */
      textVisible: false,
    }
  },
  props: {
    /**
     * ID
     */
    id: {
      type: String,
      default: '',
    },
    /**
     * Value値
     */
    value: {
      type: String,
      default: '',
    },
    /**
     * 表示のみ
     */
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    /**
     * Error判定
     */
    error: {
      type: Boolean,
      default: false,
    },
    /**
     * プレースホルダー
     */
    placeholder: {
      type: String,
      default: '',
    },
  },
  setup(props, context) {
    /**
     * password
     * @param {string} val パスワード
     */
    const password = computed({
      get: () => props.value,
      set: (val: string) => context.emit('input', val),
    })

    return {
      password,
    }
  },
  methods: {
    /**
     * Enter Push
     */
    emitEnter() {
      /**
       * Enterボタン押下を通知する
       * @event login
       * @type {Object}
       */
      this.$emit('enter')
    },
    /**
     * 入力欄がフォーカスされたことを通知する
     */
    emitFocus() {
      /**
       * 入力欄がフォーカスされたことを通知する
       * @event focus
       * @type {Object}
       */
      this.$emit('focus')
    },
    /**
     * 入力欄からフォーカスが外れたことを通知する
     */
    emitBlur() {
      /**
       * 入力欄からフォーカスが外れたことを通知する
       * @event blur
       * @type {Object}
       */
      this.$emit('blur')
    },
    changeInputType() {
      /**
       * パスワードをテキスト表示に変更切り替え
       */
      this.textVisible = !this.textVisible
    },
  },
})
</script>

<style lang="scss" scoped>
.password-view-change-parts {
  position: relative;
  width: 100%;

  &__button {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translate(0, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    opacity: 0.5;
    border-radius: 2px;

    &--text {
      background: #000;

      svg path {
        fill: #fff;
      }
    }
  }
}
</style>
